/** Canonical AiClaims portal paths (no /aiclaims prefix). */
export const AICLAIMS_WELCOME_PATH = '/welcome'
export const AICLAIMS_DASHBOARD_PATH = '/dashboard'
export const AICLAIMS_DEMO_PATH = '/demo'

export const AICLAIMS_PORTAL_PATHS = [
  AICLAIMS_WELCOME_PATH,
  AICLAIMS_DASHBOARD_PATH,
  '/runs',
  '/workflows',
  '/cases',
  '/gta',
  '/call-auditing',
  '/call-analysis',
  '/costs',
  '/reports',
  AICLAIMS_DEMO_PATH,
] as const

export type AiClaimsPortalPath = (typeof AICLAIMS_PORTAL_PATHS)[number]

const LEGACY_PREFIX = '/aiclaims'

/** Map legacy /aiclaims/* URLs to canonical portal paths. */
export function stripLegacyAiClaimsPrefix(pathname: string): string | null {
  if (pathname === LEGACY_PREFIX) {
    return AICLAIMS_WELCOME_PATH
  }
  if (!pathname.startsWith(`${LEGACY_PREFIX}/`)) {
    return null
  }
  return pathname.slice(LEGACY_PREFIX.length) || AICLAIMS_WELCOME_PATH
}

export function isAiClaimsPortalPath(pathname: string): boolean {
  if (AICLAIMS_PORTAL_PATHS.some((p) => pathname === p)) {
    return true
  }
  if (pathname.startsWith('/runs/')) {
    return true
  }
  if (pathname.startsWith('/gta/')) {
    return true
  }
  return false
}

/** Paths safe to redirect from a WyseHub host without stealing shared routes. */
export function isExclusiveAiClaimsPortalPath(pathname: string): boolean {
  return pathname !== AICLAIMS_DEMO_PATH && isAiClaimsPortalPath(pathname)
}

/** Translate a clean portal URL to the internal Next.js route namespace. */
export function toInternalAiClaimsPath(pathname: string): string | null {
  if (!isAiClaimsPortalPath(pathname)) {
    return null
  }
  return `${LEGACY_PREFIX}${pathname}`
}
